import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AuthLayout from "./components/layout/AuthLayout";
import MainLayout from "./components/layout/MainLayout";

import Landing from "./pages/Landing";
import Register from "./components/Auth/Register";
import Login from "./components/Auth/Login";
import MembershipCategory from "./components/Auth/Member";
import ProtectedRoute from "./route/ProtectedRoutes";
import Request from "./pages/Request";
import Messages from "./pages/Messages";
import Profile from "./pages/Profile";
import ActivityReportForm from "./pages/ActivityReportForm";
import Notification from "./pages/Allannouncement";
import Announcements from "./pages/Announcements";

// Admin components
import AdminLayout from "./admin/components/AdminLayout";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public (unauthenticated) routes */}
          <Route
            path="/"
            element={
              <AuthLayout>
                <Landing />
              </AuthLayout>
            }
          />
          <Route
            path="/register"
            element={
              <AuthLayout>
                <Register />
              </AuthLayout>
            }
          />
          <Route
            path="/login"
            element={
              <AuthLayout>
                <Login />
              </AuthLayout>
            }
          />
          <Route
            path="/member"
            element={
              <AuthLayout>
                <MembershipCategory />
              </AuthLayout>
            }
          />

          {/* PROTECTED ADMIN ROUTES */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminLayout />
              </ProtectedRoute>
            }
          />

          {/* Protected routes for regular users */}
          <Route
            path="/announcements"
            element={
              <ProtectedRoute>
                <MainLayout activeNavItem="announcements">
                  <Announcements />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/request"
            element={
              <ProtectedRoute>
                <MainLayout activeNavItem="request">
                  <Request />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <MainLayout activeNavItem="messages">
                  <Messages />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MainLayout activeNavItem="profile">
                  <Profile />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/add"
            element={
              <ProtectedRoute>
                <MainLayout activeNavItem="reports">
                  <ActivityReportForm />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <MainLayout activeNavItem="notifications">
                  <Notification />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Redirect unknown routes → announcements (authenticated home) */}
          <Route path="*" element={<Navigate to="/announcements" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;